import {
  DateFilter,
  GuidFilter,
  IdFilter,
  StringFilter,
} from "react3l-advanced-filters";
import { ModelFilter } from "react3l-common";

export class ProjectFilter extends ModelFilter {
  public id?: IdFilter = new IdFilter();
  public code?: StringFilter = new StringFilter();
  public name?: StringFilter = new StringFilter();
  public address?: StringFilter = new StringFilter();
  public projectTypeId?: IdFilter = new IdFilter();
  public projectGroupId?: IdFilter = new IdFilter();
  public projectStatusId?: IdFilter = new IdFilter();
  public organizationId?: IdFilter = new IdFilter();
  public regionId?: IdFilter = new IdFilter();
  public landBankId?: IdFilter = new IdFilter();
  public startedAt?: DateFilter = new DateFilter();
  public endedAt?: DateFilter = new DateFilter();
  public investorName?: StringFilter = new StringFilter();
  public note?: StringFilter = new StringFilter();
  public createdAt?: DateFilter = new DateFilter();
  public updatedAt?: DateFilter = new DateFilter();
  public rowId?: GuidFilter = new GuidFilter();
  public search?: string = null;
  public biddingPackageCode?: StringFilter = new StringFilter();
}
